import { questionSetToBenchmarkFormat } from "../../../../utils/goalsUtils"

export const FetchTrendBenchMarkDataStart = (state) => {
    return {
        ...state,
        TrendBenchMarkDataApi: {
            isProcessing: true,
            data: null,
            error: false,
            message: ''
        }
    }

}

export const FetchTrendBenchMarkDataSuccess = (state, payload) => {
    return {
        ...state,
        TrendBenchMarkDataApi: {
            isProcessing: false,
            data: getBenchMarkData(payload),
            error: false,
            message: payload.message
        },
        isBenchMarkDataAlreadyFetched: true
    }

}

export const FetchTrendBenchMarkDataFailed = (state, payload) => {
    return {
        ...state,
        TrendBenchMarkDataApi: {
            isProcessing: false,
            data: null,
            error: payload.error,
        },
    }

}

const getBenchMarkData = (response) => {
    let benchmarkData = []
    if (response.data && response.data.data && response.data.data.response) {
        benchmarkData = response.data.data.response
    }
    if (benchmarkData.length === 0) {
        benchmarkData = questionSetToBenchmarkFormat(response.projectDetails.questionSet, response.projectDetails.projectType)
    }
    return benchmarkData
}
